export default "__VITE_ASSET__DGyD99uA__"